import { IAppState } from 'shared/common/state';

export const isErrorSelector = (state: IAppState): boolean => {
  return state.consultantCianChat.isError;
};
